/* import __COLOCATED_TEMPLATE__ from './event-part-text-component.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';

const NEW_TICKET_TYPE_REF_KEY = 'new_ticket_type_name';
const TICKET_TYPE_REF_KEYS = ['previous_ticket_type_name', NEW_TICKET_TYPE_REF_KEY];

interface EventPartToken {
  reference?: string;
  value?: string;
  label?: string;
  name?: string;
  emoji?: string;
}

interface RequestTypeLike {
  name?: string | null;
  emoji?: string | null;
}

interface ConversationLike {
  requestType?: RequestTypeLike | null;
}

interface PartLike {
  conversation?: ConversationLike | null;
}

interface EventPartTextSignature {
  Args: {
    token?: EventPartToken | null;
    part?: PartLike | null;
    conversation?: ConversationLike | null;
  };
}

export default class EventPartTextComponent extends Component<EventPartTextSignature> {
  get displayText(): string {
    let token = this.args.token;
    if (!token) {
      return '';
    }
    let ref = token.reference;
    let isTicketTypeRef = ref != null && TICKET_TYPE_REF_KEYS.includes(ref);
    let emoji = token.emoji;
    let nameFromToken = token.name ?? token.label ?? token.value ?? '';
    let name =
      emoji && nameFromToken && String(nameFromToken).trim() === String(emoji).trim()
        ? ''
        : nameFromToken;
    let requestType =
      this.args.conversation?.requestType ?? this.args.part?.conversation?.requestType;
    if (
      isTicketTypeRef &&
      ref === NEW_TICKET_TYPE_REF_KEY &&
      requestType &&
      (!name || !String(name).trim())
    ) {
      name = requestType.name ?? '';
      if (!emoji) {
        emoji = requestType.emoji ?? '';
      }
    }
    let nameStr = name != null ? String(name).trim() : '';
    if (emoji) {
      return nameStr ? `${emoji} ${nameStr}` : emoji;
    }
    return nameStr || token.value || '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Conversation::Stream::EventPartTextComponent': typeof EventPartTextComponent;
    'conversation/stream/event-part-text-component': typeof EventPartTextComponent;
  }
}
